import { IAnalyticsEventsTypesNamesResponse } from '../../models/AnaliticsEventModels'
import { ILenConfigState } from '../types'

export const SET_LEN_CONFIG = "SET_LEN_CONFIG";
export const SET_PHONE_VISIBLE_ON_PAGE = "SET_PHONE_VISIBLE_ON_PAGE";
export const SET_ANALYTICS_EVENT_TYPES_NAMES = "SET_ANALYTICS_EVENT_TYPES_NAMES";


export interface SetLenConfigction{
    type : typeof SET_LEN_CONFIG;
    payload: ILenConfigState;
}
export interface SetPhoneVisibleOnPage{
  type : typeof SET_PHONE_VISIBLE_ON_PAGE;
  payload: boolean;
}
export interface SetAnalyticsEventTypesNamesAction {
  type : typeof SET_ANALYTICS_EVENT_TYPES_NAMES;
  payload: IAnalyticsEventsTypesNamesResponse;
}

export type LenConfigActions =
  | SetLenConfigction
  | SetPhoneVisibleOnPage
  | SetAnalyticsEventTypesNamesAction